module.exports = __webpack_public_path__ + "img/kof_no.295ab7ca.png";